<template lang="pug">
    div
        Card.a8-page-description-card
            Row(type="flex" align="middle" justify="space-between")
                Col
                    h2 {{ $t('servicegroup.pageTitleText') }}
                Col
                    ExplainBtn(:objectExplanation="objectsExplanation")
            p Group your slbs for DNS resolution.
            strong You have created {{ usage.used }} of {{ usage.max }} servicegroups.

        // h2 {{ $t('servicegroup.pageTitleText') }}
        RcmTable(
            :esIndex="esIndex"
            :esIndexFields="esIndexFields"
            :addButtonText="addButtonText"
            :userCanCreate="true"
            :userCanIndex="true"
            :userCanDelete="true"
            :drawerTitleKey="drawerTitleKey"
            :sort="sort"
            ref="rcmTable"
            :searchView="$options.name"
            :sectionInfo="sectionInfo"
            primarySearchKey="serviceGroupName"
            :primarySearchKeyI18="$t('servicegroup.serviceGroupName')"
            :isCreateBtnDisabled="!$can('write', 'groupResourcesPermission','ServiceGroup')"
            :isEditBtnDisabled="!$can('write', 'groupResourcesPermission','ServiceGroup')"
            :isDeleteBtnDisabled="!$can('write', 'groupResourcesPermission','ServiceGroup')"
        )
        //- ResourceFinder(v-else)
        DependencyObjectModal(:isDependencyObjectAlertShown="isDependencyObjectAlertShown" :dependencyConfig="dependencyConfig" @closeDependencyObjectAlert="isDependencyObjectAlertShown = false")
</template>
<script>
import Vue from "vue";
import RcmTable from "@/components/RcmTable_v2";
import bus from "@/libs/bus.js";
import JsonPoptip from "@/components/JsonPoptip";
import ObjectLogBtn from "@/components/ObjectLogBtn";
import ResourceFinder from "@/components/Home/ResourceFinder";
import DependencyObjectModal from "@/components/DependencyObjectModal";

Vue.component("JsonPoptip", JsonPoptip);
Vue.component("ObjectLogBtn", ObjectLogBtn);

import { getGroupAsset } from "@/api/groupasset.js";
import { getFormOptions } from "@/api/formoptions";

import {
    settingZoneExplain,
    groupName,
    serviceGroupName,
    recordType,
    slbs,
    description,
    isEnabled,
    isEnforceProtectWithPaw,
    isEnforceProtectWithSwitch,
} from "./fields.js";

export default {
    name: "ServiceGroup",
    components: { RcmTable, ResourceFinder, DependencyObjectModal },
    data() {
        return {
            esIndex: "rcm-servicegroup",
            drawerTitleKey: "serviceGroupName",
            sort: [{ modifiedDate: { order: "desc" } }],
            assetCategory: "servicegroups",
            usage: { used: "", max: "", available: "" },
            // showTable: true,
            dependencyConfig: {
                objectKey: "slbnames",
                queryKey: "slbnames",
                path: "/slbsetting",
                name: "slbsetting",
                hasPermission: this.$can("write", "groupResourcesPermission", "SlbsManage"),
            },
            isDependencyObjectAlertShown: false,
            objectsExplanation: {},
        };
    },
    computed: {
        addButtonText() {
            return this.$i18n.t("servicegroup.createText");
        },
        sectionInfo() {
            return [];
        },
        esIndexFields() {
            return this.$store.getters.isAdmin
                ? {
                      action: {},
                      settingZoneExplain: settingZoneExplain(this),
                      groupName: groupName(this),
                      serviceGroupName: serviceGroupName(this),
                      _id: {},
                      runningStat: {},
                      isenabled: isEnabled(this),
                      recordType: recordType(this),
                      slbs: slbs(this),
                      protectSlbs: {},
                      isEnforceProtect: this.$store.getters.getServiceGroupConfig.isEnforceProtectWithPaw
                          ? isEnforceProtectWithPaw(this)
                          : isEnforceProtectWithSwitch(this),
                      createdDate: {},
                      modifiedDate: {},
                      description: description(this),
                      status: {},
                      objectLog: {},
                  }
                : {
                      action: {},
                      settingZoneExplain: settingZoneExplain(this),
                      groupName: groupName(this),
                      serviceGroupName: serviceGroupName(this),
                      _id: {},
                      runningStat: {},
                      isenabled: isEnabled(this),
                      recordType: recordType(this),
                      slbs: slbs(this),
                      protectSlbs: { withForm: false },
                      createdDate: {},
                      modifiedDate: {},
                      description: description(this),
                      status: {},
                      objectLog: {},
                  };
        },
    },
    watch: {
        "$i18n.locale": {
            deep: true,
            handler: function () {
                this.objectsExplanation = this.$i18n.t("objectExplanation." + this.esIndex);
            },
        },
    },
    methods: {
        getAssetData() {
            getGroupAsset({
                category: this.assetCategory,
                groupNames: [this.$store.state.queryGroupName],
            }).then((res) => {
                let { used, max } = res.data;
                let available = max - used;
                this.usage = { used, max, available };
            });
        },
        async checkObjectCanBeCreated() {
            let result = await getFormOptions(
                `${this.dependencyConfig.objectKey}?groupName=${this.$store.state.queryGroupName}&${this.dependencyConfig.queryKey}=***`
            );
            this.isDependencyObjectAlertShown = result.data.options.length == 0;
        },
    },
    mounted() {
        this.getAssetData();
        // let permission = this.$store.getters.currentGroupRolePermissions.groupResourcesPermission;
        // let pagePermission = permission.children.find(e => e.name == "ServiceGroup");
        // this.showTable = pagePermission.children.every(e => e.read == true);
    },
    created() {
        this.objectsExplanation = this.$i18n.t("objectExplanation." + this.esIndex);
        this.checkObjectCanBeCreated();
        // 監聽以自己組件為名的事件
        bus.$on(this.$options.name, (busEvent) => {
            bus.$emit(busEvent);
        });
    },
    destroyed() {},
    beforeDestroy() {
        bus.$off(this.$options.name);
    },
};
</script>



// WEBPACK FOOTER //
// src/view/ServiceGroup/Page.vue